export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const formatDateTime = (dateString: string | null | undefined): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const toLocalDate = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const localDateToISO = (dateString: string): string =>
  new Date(`${dateString}T00:00:00`).toISOString();

export const getToday = (): string => {
  return toLocalDate(new Date());
};

export const addDays = (dateString: string, days: number): string => {
  const date = new Date(`${dateString}T00:00:00`);
  date.setDate(date.getDate() + days);
  return toLocalDate(date);
};

export const isToday = (dateString: string): boolean => {
  const today = getToday();
  return dateString === today;
};

export const isPast = (dateString: string): boolean => {
  const today = getToday();
  return dateString < today;
};

export const isFuture = (dateString: string): boolean => {
  const today = getToday();
  return dateString > today;
};

export interface WeekDay {
  date: string;
  dayName: string;
  dayShort: string;
}

export const getWeekDates = (weekOffset = 0): WeekDay[] => {
  const now = new Date();
  const currentDay = now.getDay();
  const monday = new Date(now);
  monday.setDate(now.getDate() - currentDay + 1 + (weekOffset * 7));

  const week: WeekDay[] = [];
  for (let i = 0; i < 5; i++) {
    const day = new Date(monday);
    day.setDate(monday.getDate() + i);
    week.push({
      date: toLocalDate(day),
      dayName: day.toLocaleDateString('pt-BR', { weekday: 'long' }),
      dayShort: day.toLocaleDateString('pt-BR', { weekday: 'short' }),
    });
  }
  return week;
};
